module.exports = __webpack_public_path__ + "img/icon(15).25cf0ae7.png";